import type { LoaderProps } from '@opendoor/bricks-next';
import dynamic from 'next/dynamic';

/**
 * Client-only wrapper for the bricks-next Loader.
 *
 * The bricks-next Loader uses lottie-react-native which requires DOM APIs
 * and cannot render during SSR. This wrapper uses next/dynamic with ssr: false
 * to ensure it only renders on the client.
 */
export const BricksNextLoader = dynamic(
  () => import('@opendoor/bricks-next').then((mod) => mod.Loader),
  { ssr: false },
) as React.ComponentType<LoaderProps>;
